export const PHONE_DISPLAY = "0433 851 045";
export const PHONE_TEL = "tel:+61433851045";
export const BUSINESS_NAME = "Rapid Shine Mobile Carwash & Detailing";
export const SHORT_NAME = "Rapid Shine";
export const SERVICE_AREA = "Newcastle, NSW";
export const GBP_URL = "https://maps.app.goo.gl/7i4vjSs97qPfGjoo7?g_st=ic";
export const EMAIL = "rapidshinemobilecarwash@gmail.com";
